"use strict";

var _useSelectedGlobalSupplierFetchQuery;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { c as _c } from "react/compiler-runtime";
import { initPersistedEnvironment } from '@autoguru/relay';
import { useEffect, useState } from 'react';
import { fetchQuery, graphql } from 'react-relay/hooks';
import { useGlobalSupplier } from './GlobalSupplierProvider';
const createResource = promise => {
  let status = 'pending';
  let result = null;
  const suspender = promise.then(data => {
    status = 'success';
    result = data.supplier;
  }, error => {
    status = 'error';
    result = error;
  });
  return {
    read() {
      if (status === 'pending') {
        throw suspender;
      }
      if (status === 'error') {
        throw result;
      }
      return result;
    }
  };
};
export const useSelectedGlobalSupplier = () => {
  const $ = _c(6);
  const {
    state
  } = useGlobalSupplier();
  const [resource, setResource] = useState(null);
  let t0;
  if ($[0] !== state) {
    t0 = () => {
      if (!(state !== null && state !== void 0 && state.globalSupplierSlug)) {
        return;
      }
      const environment = initPersistedEnvironment();
      const fetchSupplier = fetchQuery(environment, _useSelectedGlobalSupplierFetchQuery !== void 0 ? _useSelectedGlobalSupplierFetchQuery : _useSelectedGlobalSupplierFetchQuery = require("../../relay/__generated__/useSelectedGlobalSupplierFetchQuery.graphql"), {
        slug: state.globalSupplierSlug
      }, {
        fetchPolicy: "store-or-network"
      }).toPromise();
      setResource(createResource(fetchSupplier));
    };
    $[0] = state;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = state === null || state === void 0 ? void 0 : state.globalSupplierSlug;
  let t2;
  if ($[2] !== t1) {
    t2 = [t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t0, t2);
  let t3;
  if ($[4] !== resource) {
    t3 = (resource === null || resource === void 0 ? void 0 : resource.read()) || {
      id: null,
      dbId: null,
      slug: null,
      name: null
    };
    $[4] = resource;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};